import { GroupModel } from '../group/types';
import { SalesTeamLightModel, SalesTeamModel } from '../sales-team/types';

export const userFeatureKey = 'users';

export class RegisterModel {
  constructor(email: string, password: string, username: string) {
    this.email = email;
    this.password = password;
    this.username = username;
  }
  email: string;
  password: string;
  username: string;
}

export type UserModel = {
  firstName: string;
  lastName: string;
  email: string;
  contactPictureId?: number;
  contactPictureFile?: File;
  salesPersonCommissionPlanId?: number;
  sharedCommissionPlanId?: number;
  salesTeamIds?: number[];
  /** Telephony extension: mapping key for call attribution. */
  telephonyExtension?: string;
  mainSalesTeamId?: number;
  groupId: number;
  groups: GroupModel[];
  workScheduleId?: number;
};

export type LockoutModel = {
  email: string;
  activate: boolean;
};

export class User {
  /** Telephony extension: mapping key for call attribution. */
  telephonyExtension?: string;
  id: number;
  contactId: number;
  contactName: string;
  contactFirstName: string;
  contactLastName: string;
  contactPicturePath: string;
  contactPictureId?: number;
  contactPictureFile?: File;
  aspNetUserEmail: string;
  aspNetUserUserName: string;
  active: boolean;
  aspNetUserEmailConfirmed: boolean;
  firstName: string;
  lastName: string;
  email: string;
  salesPersonCommissionPlanId?: number;
  salesPersonCommissionPlanName?: string;
  sharedCommissionPlanId?: number;
  sharedCommissionPlanName?: string;
  userSalesTeams: SalesTeamModel[];
  salesTeamIds?: number[];
  mainSalesTeamId?: number;
  mainSalesTeamName?: string;
  groupId: number;
  groups: GroupModel[];
  workScheduleId?: number;
}

export type UserDetailModel = {
  /** Telephony extension: mapping key for call attribution. */
  telephonyExtension?: string;
  id: number;
  contactId: number;
  contactName: string;
  contactFirstName: string;
  contactLastName: string;
  contactPictureId: number;
  contactPicturePath: string;
  aspNetUserUserName: string;
  aspNetUserEmail: string;
  aspNetUserEmailConfirmed: boolean;
  mainSalesTeamId: number;
  mainSalesTeamName: string;
  salesPersonCommissionPlanId: number;
  salesPersonCommissionPlanName: string;
  sharedCommissionPlanId: number;
  sharedCommissionPlanName: string;
  groupId: number;
  groups: GroupModel[];
  userSalesTeams: SalesTeamLightModel[];
  workScheduleId?: number;
  workScheduleName: string;
};

export class Avatar {
  constructor(contactName: string, url: string, bgColor: string) {
    this.contactName = contactName;
    this.url = url;
    this.bgColor = bgColor;
  }
  contactName: string;
  url: string;
  bgColor: string = 'cccccc';
}

export type UserConnectionHistory = {
  id: number;
  userId: string;
  connectionDate: Date;
};

export type CurrentUserModel = {
  id: number;
  contactId: number;
  contactName: string;
  contactPictureId?: number;
  contactPicturePath: string;
  timeZoneId: string;
};
